import { viewModes } from './constants';

export type TYPES = {
  ORGANIZATION: 'NEET_PG' | 'PW';
  VIDEO_TYPE: 'aws_video' | 'youtube' | 'penpencilvdo';
};
export const CURIOUS_JUNIOR = 'CURIOS_JUNIOR';
export const XYLEM = 'XYLEM';
export const STUDIO_X = 'STUDIO_X';
export const EXTERNAL_ORGANIZATIONS = ['NEET_PG', CURIOUS_JUNIOR];

export const WARNING_MESSAGE_IN_IE =
  'Please note that this website uses ES6 features that are not fully supported by Internet Explorer. For the best experience, we recommend using a modern browser like Chrome, Firefox, Edge, or Safari';

export const FIVE_MINUTES_TIME = 5 * 60;

export const SCHEDULE_STATUS_COMPLETED = 'COMPLETED';

export const optionsList = [
  {
    name: 'No buffer in old video player',
  },
  {
    name: 'Black screen appearing in new video player',
  },
  {
    name: 'Poll issue in new video player',
  },
  {
    name: 'Unresponsiveness of new video player',
  },
  {
    name: 'Others',
  },
];

export enum CLIENT_TYPE {
  ADMIN = 'admin',
  STUDY = 'study',
  NEET_PG = 'neet_pg',
  ONLY_IAS = 'only_ias',
  TEACHER_PORTAL = 'teacher_portal',
  STUDIO_X = 'studio_x',
  SME = 'sme',
  ERP = 'erp',
  QBG_ADMIN = 'qbg_admin',
}

export const IMAGE_STATUS = {
  UNDER_REVIEW: 'UNDER_REVIEW',
  SPAMMED_IMAGE: 'SPAMMED_IMAGE',
  APPROPRIATE_IMAGE: 'APPROPRIATE_IMAGE',
  ACTIVE: 'Active',
};
export enum BATCH_TYPE {
  PREMIUM = 'MASTER',
  NORMAL = 'NORMAL',
}
export enum CHAT_TITLE {
  SAARTHI = 'Ask Saarthi',
  PREMIUM = 'Personal Teacher',
}

export enum ADDONS_TYPE {
  SAARTHI = 'SAARTHI',
  KHAZANA = 'KHAZANA',
}
export enum SAARTHI_TYPES {
  ASKSAARTHI = 'ASKSAARTHI',
  KHAZANA = 'KHAZANA',
}

export enum VIDEO_TYPE {
  'AWS_VIDEO' = 'awsVideo',
  'PENPENCILVDO' = 'penpencilvdo',
  'YOUTUBE' = 'youtube',
  'ID3' = 'id3',
}

export enum POLL_CONNECTION_TYPE {
  'ID3' = 'id3',
  'U_WEB_SOCKET' = 'uwebsocket',
  'MQTT' = 'mqtt',
}

export enum DEVICE_TYPE {
  'IOS' = 'ios',
  'CHROME' = 'chrome',
}

export enum COACH_TYPE {
  COACH = 'coach',
  MENTOR = 'mentor',
}

export enum TEACHER_STATUS {
  ABSENT = 'Absent',
  BREAK = 'Break',
  LEAVE = 'Leave',
  BUSY = 'Busy',
}

export enum SOURCE_MESSAGE {
  OTHER_COACH = '(Other Coach)',
  OTHER_MENTOR = '(Other Mentor)',
}
export enum VIDEO_KEYSYSTEMS {
  CLEARKEY = 'org.w3.clearkey',
  WIDEVINE = 'com.widevine.alpha',
  FAIRPLAY = 'com.apple.fps.1_0',
}
export enum GCP_CDN_TYPE {
  MEDIA = 'media',
  CLOUD = 'cloud',
}
export enum DRM_PROVIDER {
  PALLYCON = 'Pallycon',
}

export interface VIDEO_KEY_SOURCES {
  src?: string;
  type?: string;
  withCredentials?: boolean;
  cacheEncryptionKeys?: boolean;
  headers?: Record<string, string>;
  keySystems?: Record<string, Record<string, string | Function>>;
}
export enum MODEL_TYPE {
  THREE_D_MODEL = 'THREE_D_MODEL',
  URL = 'URL',
}

export enum REASON_OF_LDM_APPEAR {
  SETTING_FLOW = 'setting_flow',
  UNSTABLE_INTERNET = 'unstable_internet',
}
export interface VIDEO_KEY_SOURCES {
  src?: string;
  type?: string;
  withCredentials?: boolean;
  cacheEncryptionKeys?: boolean;
  headers?: Record<string, string>;
  keySystems?: Record<string, Record<string, string | Function>>;
}

export interface SENTRY_CONFIG_DATA_TYPE {
  enabled: boolean;
  sampleRate: number;
}
export enum TOOL_TIP_CONTENT {
  POLL_STARTED = 'Poll has started. Go live to attempt.',
}

export enum SingleScheduelingDataEnum {
  DPP_VIDEO = 'DPP_VIDEO',
  NOTES = 'NOTES',
  DPP = 'DPP',
  DPP_PDF = 'DPP_PDF',
}

export enum ShowNotifcationTitleEnum {
  DPP_PDF_DOWNLOAD_TITLE = 'This is a premium feature. Please purchase batch to acces',
}

export enum UNLEASH_FEATURE_FLAGS {
  VIDEO_SYNC_STATS_ROLLOUT = 'video-sync-stats-rollout',
  TOPIC_WISE_TIMELINE = 'topic-wise-timeline',
  VIDEO_SYNC_STATS_ROLLOUT_SKILLS = 'video-sync-stats-rollout-skills',
  RECORD_POLL_FEATURE_ROLLOUT = 'Recorded_Lecture_Polls',
}

export const UNLEASH_VARIANTS_KEYS = {
  TEST_GROUP: 'TestGroup',
  CONTROL_GROUP: 'ControlGroup',
  DISABLED: 'disabled',
};

export const UNLEASH_VARIANTS_VALUES = {
  RECORD_POLL_ENABLE: 'RECORDED_POLL_ENABLE',
};

export enum M_WEB_ACTIONS_KEYS {
  ATTACHMENT = 'Attachment',
  DOCUMENTS = 'Documents',
  RATING = 'Rating',
  REPORT = 'Report',
}

export enum M_WEB_ACTIONS_TITLE_ENUM {
  ATTACHMENT = 'Attachment',
  DOCUMENTS = 'Documents',
  RATING = 'Rating',
  REPORT = 'Report',
  TIMELINE = 'Timeline',
  DOUBTS = 'Doubts',
  COMMENTS = 'Comments',
  CHATS = 'Chats',
  PERSONAL_TEACHER = 'Personal Teacher',
  ASK_SAARTHI = 'Ask Saarthi',
  THREED_LIBRARY = '3D Library',
  NOTES = 'Notes',
  THREED = 'ThreeD',
  LINK = 'Link',
  ASK_AI = 'Ask AI',
}

export enum SINGLE_SCHEDULING_TITLE_ENUM {
  DPP = 'DPP',
  NOTES = 'Notes',
  DPP_PDF = 'DPP PDF',
  DPP_VIDEO = 'DPP Videos',
}

export enum DPP_QUIZ_TAG_ENUM {
  REATTEMPT = 'Reattempt',
  RESUME = 'Resume',
  START = 'Start',
  START_DISABLED = 'StartDisabled',
  ATTEMPTED = 'Attempted',
}

export enum VideoContainerType {
  HLS = 'HLS',
  DASH = 'DASH',
}

export enum ChatRoleType {
  PRIMARY_TEACHER = 'primaryTeacher',
  STUDENT = 'student',
}

export enum CommentRoleType {
  STUDENT = 'Student',
  ADMIN = 'Admin',
  TEACHER = 'Teacher',
}

export type ExactAudioTrack = {
  label: string;
  enabled: boolean;
  language: string;
};

export type videoUrlDetailsType = {
  type: string;
  vType: string;
  videoContainerType: VideoContainerType;
  childId?: string;
  parentId?: string;
  secondaryParentId?: string;
  secondaryChildId?: string;
  src?: string;
  videoId?: string;
  disableCMAF?: boolean;
};

export interface DoubtSolutionEventData {
  userId: string;
  scheduleId: string;
  slideId: string;
  doubtId: string;
  dRoomId: string;
  solutionId: string;
}

export enum DoubtMode {
  ASK_DOUBT = 'ASK_DOUBT',
  MY_DOUBTS = 'MY_DOUBTS',
}

export type UNLEASH_ANAYTICS_PAYLOAD = {
  variantName: string;
  experimentName: string;
  featureEnabled: boolean;
};

export enum SLIDE_NAVIGATION_POSITION {
  UP = 'up',
  DOWN = 'down',
}

export enum AckStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export type PolicyAcknowledgementPayload = {
  typeId: string;
  status: AckStatus;
};

export enum ChatPolicyModalText {
  CONFIRM_TITLE = 'Chat Access Pending',
  CONFIRM_DESC = 'Accept the chat policy to participate in chat & comments. You can still watch the lecture without it.',
  ACCEPT = 'Accept',
  REJECT = 'Reject',
  ACCEPT_POLICY = 'Accept Policy',
  NEW_POLICY_TOOLTIP = 'Chat Policy has been updated!',
  POLICY_ACCEPTED_BANNER_TEXT = 'You have accepted the Policy. Please follow it to avoid being blocked.',
  POLICY_REJECTED_BANNER_TEXT = 'To participate in the chat please read and accept our Chat Policy.',
  CHAT_POLICY_FAILED_TO_LOAD = 'Failed to load policy. Please retry.',
  RETRY = 'Retry',
}
export type RoleType = {
  name: string;
  id: string;
};

export type ViewModeType = (typeof viewModes)[keyof typeof viewModes];

export type UserModel = {
  status: string;
  id: string;
  firstName: string;
  lastName: string;
  primaryNumber: string;
  countryCode: string;
  countryGroup: string;
  username: string;
  uniqueCode: string;
  email: string;
  isVerifiedEmail: boolean;
  profileId: {
    exams: string[];
    _id: string;
    created: string;
    createdAt: string;
    class: string;
    programId: string;
    wallet: number;
    totalRewards: number;
    coins: {
      bankTransferCoins: number;
      voucherCoins: number;
      commonCoins: number;
      walletCoins: number;
      totalCoins: number;
      redeemedCoins: number;
    };
    parentDetails: unknown;
    isProfileCompleted: boolean;
    children: unknown[];
    cohortId: string;
    needCohortUpdate: boolean;
    cohortUpdatedAt: string;
  };
  dateOfBirth: string | null;
  phones: string[];
  address: string | null;
  primary: string | null;
  organization: {
    _id: string;
    status: string;
    usersCount: number;
    name: string;
    website: string;
    createdAt: string;
    updatedAt: string;
    phones: string[];
    rejectionComments: string[];
    enrolmentType: string;
    primaryContact: string;
  };
  roles: RoleType[];
  androidVersion: number;
  iosVersion: number;
  webVersion: number;
  nameUpdateBlockedUntil: string;
  isScholar: boolean;
  oneRoles: unknown[];
};
